"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GENDER_SUB_GENDERS = exports.GENDER_LABELS = void 0;
exports.isSubGenderForGender = isSubGenderForGender;
const enums_1 = require("../enums");
/** Display labels for primary genders that have sub-genders. */
exports.GENDER_LABELS = {
  [enums_1.Gender.Female]: 'Woman',
  [enums_1.Gender.Male]: 'Man',
  [enums_1.Gender.NonBinary]: 'Nonbinary'
};
/** Sub-genders available for each primary gender. */
exports.GENDER_SUB_GENDERS = {
  [enums_1.Gender.Female]: [enums_1.SubGender.CisWoman, enums_1.SubGender.WomanAndNonbinary, enums_1.SubGender.TransWoman, enums_1.SubGender.Transfeminine, enums_1.SubGender.IntersexWoman],
  [enums_1.Gender.Male]: [enums_1.SubGender.CisMan, enums_1.SubGender.ManAndNonbinary, enums_1.SubGender.TransMan, enums_1.SubGender.Transmasculine, enums_1.SubGender.IntersexMan],
  [enums_1.Gender.NonBinary]: [enums_1.SubGender.Agender, enums_1.SubGender.Bigender, enums_1.SubGender.Genderfluid, enums_1.SubGender.Intersex, enums_1.SubGender.Genderqueer, enums_1.SubGender.GenderNonconforming, enums_1.SubGender.Pangender, enums_1.SubGender.Polygender, enums_1.SubGender.Transgender, enums_1.SubGender.TwoSpirit]
};
function isSubGenderForGender(gender, subGender) {
  var _exports$GENDER_SUB_G;
  return ((_exports$GENDER_SUB_G = exports.GENDER_SUB_GENDERS[gender]) !== null && _exports$GENDER_SUB_G !== void 0 ? _exports$GENDER_SUB_G : []).includes(subGender);
}
//# sourceMappingURL=gender.constants.js.map